<template>
    <div class="pdf-viewer-container">


        <div v-if="teacherAudioUrl" style="position: absolute; top: 52px; right: 16px;" class="premium-btn-wrapper">
            <v-btn small class="rounded-lg font-rubik premium-download-btn" color="white"
                :class="visiblePdfContainerWidth > 700 ? 'pr-4' : ''" title="Descargar PDF" @click="downloadPdf">
                <lucide-download :class="visiblePdfContainerWidth > 700 ? 'mr-1' : ''" :size="16" />
                <span v-if="visiblePdfContainerWidth > 700">
                    Descargar ahora
                </span>
            </v-btn>
        </div>


        <div v-if="loading" class="loading-container">
            <v-progress-circular indeterminate color="primary" size="30"></v-progress-circular>
            <!-- <p class="mt-3 text-caption grey--text">Cargando PDF: {{ loadingProgress }}%</p> -->
        </div>
        <div v-else-if="!loading && error" class="error-container">
            <v-alert type="error" outlined>{{ error }}</v-alert>
            <v-btn color="primary" class="mt-4" @click="loadPdf">
                Reintentar
            </v-btn>
        </div>
        <div v-else-if="!loading && !pdfUrl" class="no-pdf-container">
            <v-alert type="info" outlined>
                No se encontró el archivo PDF para este documento.
            </v-alert>
        </div>
        <div v-else class="pdf-content" style="position: relative !important;">

            <div v-if="scrollOver" class="scroll-over-overlay" style="height: 40px;"></div>

            <!-- Overlay para preguntar si quiere escuchar el audio -->
            <div v-if="showAudioPromptOverlay" class="audio-prompt-overlay-custom">
                <div class="audio-prompt-overlay-content">
                    <h3 class="mb-3 font-weight-medium">¿Deseas escuchar la explicación del profesor?</h3>
                    <p class="mb-3">Duración: {{ formatTime(audioDuration) }}</p>
                    <p class="mb-4">Escuchar la explicación te ayudará a comprender mejor los apuntes y reforzar los
                        conceptos clave para tu repaso.</p>
                    <div class="d-flex justify-space-between">
                        <v-btn color="grey lighten-1" outlined class="mr-3" @click="skipAudio">
                            No, gracias
                        </v-btn>
                        <v-btn color="primary" @click="startAudio">
                            Escuchar ahora 🔊
                        </v-btn>
                    </div>
                </div>
            </div>

            <div v-if="!teacherAudioUrl" class="pdf-controls d-flex align-center white"
                :class="{ 'fixed-controls': scrollOver }"
                :style="scrollOver ? { width: `calc(100% - ${navWidth}px)` } : {}">
                <div class="d-flex mx-auto px-4" style="width: 100%; max-width: 900px;">
                    <div :style="{ flex: visiblePdfContainerWidth > 700 ? '1' : '0' }">
                        <div class="premium-btn-wrapper">
                            <v-btn small class="rounded-lg font-rubik premium-download-btn" color="white"
                                :class="visiblePdfContainerWidth > 700 ? 'pr-4' : ''" title="Descargar PDF"
                                @click="downloadPdf">
                                <lucide-download :class="visiblePdfContainerWidth > 700 ? 'mr-1' : ''" :size="16" />
                                <span v-if="visiblePdfContainerWidth > 700">
                                    Descargar ahora
                                </span>
                            </v-btn>
                        </div>
                    </div>


                    <div v-if="visiblePdfContainerWidth > 700" class="navigation-controls d-flex align-center">


                    <!-- <v-btn style="height: 32px; width: 32px; min-width: 32px;" small @click="zoomOut" color="white"
                        title="Reducir zoom" :disabled="cssScale <= 0.25" class="rounded-lg"
                        :ripple="false">
                        <lucide-minus :size="16" />
                    </v-btn>
                    <v-btn style="height: 32px; width: 32px; min-width: 32px;" small :ripple="false" color="white"
                        class="rounded-lg mr-3" @click="zoomIn" title="Aumentar zoom" :disabled="cssScale >= 3">
                        <lucide-plus :size="16" />
                    </v-btn> -->

                        <v-text-field v-model="currentPageInput" @keydown.enter="goToPageInput"
                            @blur="handlePageInputBlur" type="number" min="1" :max="totalPages" dense hide-details flat
                            solo background-color="#ECECEC" class="page-input" style="width: 60px; text-align: center;"
                            title="Ir a la página"></v-text-field>
                        <span class="page-total grey--text text--darken-1 mx-1"> / {{ totalPages }}</span>
                    </div>


                    <div v-if="visiblePdfContainerWidth > 500" style="flex: 1" class="d-flex justify-end">
                        <div class="search-controls d-flex align-center justify-end"
                            style="width: 100%; max-width: 300px;">
                            <v-text-field v-model="searchQuery" placeholder="Buscar" dense hide-details
                                @keydown.esc="clearSearch" @keydown.enter.prevent="handleEnterKey" flat solo
                                background-color="#ECECEC" style="width: 100%; border-radius: 11px;"
                                class="self-justify-end">
                                <template v-slot:prepend-inner>
                                    <lucide-search class="mr-1" :size="16" />
                                </template>
                                <template v-slot:append>
                                    <span class="mt-1 search-results-info text-caption grey--text mx-2">
                                        {{ currentResultIndex + 1 || 0 }} / {{ searchResults.length || 0 }}
                                    </span>
                                    <v-btn icon small @click="prevResult"
                                        :disabled="!searchResults.length || currentResultIndex <= 0"
                                        title="Resultado anterior">
                                        <v-icon>mdi-chevron-up</v-icon>
                                    </v-btn>
                                    <v-btn icon small @click="nextResult"
                                        :disabled="!searchResults.length || currentResultIndex >= searchResults.length - 1"
                                        title="Resultado siguiente">
                                        <v-icon>mdi-chevron-down</v-icon>
                                    </v-btn>
                                </template>
                            </v-text-field>
                        </div>
                    </div>
                </div>
            </div>


            <!-- Barra de control de audio estilo Spotify -->
            <div v-if="teacherAudioUrl" class="audio-player-bar" :class="{ 'fixed-audio-bar': scrollOver }"
                :style="scrollOver ? { width: `calc(100% - ${navWidth}px)` } : {}">
                <div class="audio-controls d-flex align-center">
                    <!-- Controles de audio -->
                    <div class="d-flex align-center">
                        <v-btn icon small color="black" class="mx-1" @click="skipBackward"
                            title="Retroceder 10 segundos">
                            <svg height="1.1rem" class="w-4 h-4 w-5 h-5" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M4.33386 10C4.34525 10.0003 4.35662 10.0003 4.36795 10H8.25C8.66421 10 9 9.66421 9 9.25C9 8.83579 8.66421 8.5 8.25 8.5H5.43993C6.58986 6.11553 9.20412 4.5 12.0053 4.5C15.1589 4.5 17.8842 6.55843 18.9892 9.51275C19.1343 9.90072 19.5665 10.0976 19.9544 9.95247C20.3424 9.80735 20.5393 9.37521 20.3941 8.98725C19.0902 5.50112 15.8407 3 12.0053 3C8.96442 3 6.05937 4.59129 4.5 7.09919V4.75C4.5 4.33579 4.16421 4 3.75 4C3.33579 4 3 4.33579 3 4.75V9.25C3 9.66421 3.33579 10 3.75 10H4.33386Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M7.66406 20.1558V13.9858H7.62598L6.75635 14.6016C6.4834 14.7793 6.32471 14.8364 6.14062 14.8364C5.7915 14.8364 5.53125 14.5762 5.53125 14.2271C5.53125 13.9604 5.69629 13.7256 6.02002 13.5098L7.15625 12.7163C7.61328 12.4053 7.9751 12.2783 8.33057 12.2783C8.94629 12.2783 9.35889 12.7036 9.35889 13.3447V20.1558C9.35889 20.7397 9.04785 21.0762 8.5083 21.0762C7.9751 21.0762 7.66406 20.7334 7.66406 20.1558Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M10.8569 16.8804V16.4741C10.8569 13.8716 12.1011 12.1704 14.1641 12.1704C16.2334 12.1704 17.4522 13.8525 17.4522 16.4741V16.8804C17.4522 19.4766 16.1953 21.1841 14.1387 21.1841C12.0821 21.1841 10.8569 19.4956 10.8569 16.8804ZM12.5708 16.4805V16.8677C12.5708 18.6958 13.1675 19.7876 14.1514 19.7876C15.1353 19.7876 15.7319 18.6958 15.7319 16.8677V16.4805C15.7319 14.6587 15.1353 13.5669 14.1514 13.5669C13.1675 13.5669 12.5708 14.6523 12.5708 16.4805Z"
                                    fill="currentColor"></path>
                            </svg>
                        </v-btn>

                        <v-btn icon color="black" class="mx-1 play-btn" @click="toggleAudio"
                            :title="isAudioPlaying ? 'Pausar' : 'Reproducir'">
                            <v-icon size="30">{{ isAudioPlaying ? 'mdi-pause-circle' : 'mdi-play-circle' }}</v-icon>
                        </v-btn>

                        <v-btn icon color="black" small class="mx-1" @click="skipForward" title="Avanzar 10 segundos">
                            <svg height="1.1rem" class="w-4 h-4 w-5 h-5" viewBox="0 0 24 24" fill="none"
                                xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd"
                                    d="M3.60615 8.98725C4.91012 5.50112 8.15961 3 11.995 3C15.0359 3 17.9409 4.59129 19.5003 7.09919V4.75C19.5003 4.33579 19.8361 4 20.2503 4C20.6645 4 21.0003 4.33579 21.0003 4.75V9.25C21.0003 9.66421 20.6645 10 20.2503 10H15.7503C15.3361 10 15.0003 9.66421 15.0003 9.25C15.0003 8.83579 15.3361 8.5 15.7503 8.5H18.5604C17.4104 6.11553 14.7962 4.5 11.995 4.5C8.84135 4.5 6.11613 6.55843 5.01108 9.51275C4.86597 9.90072 4.43382 10.0976 4.04586 9.95247C3.6579 9.80735 3.46103 9.37521 3.60615 8.98725Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M8.16408 20.1558V13.9858H8.126L7.25637 14.6016C6.98342 14.7793 6.82473 14.8364 6.64065 14.8364C6.29152 14.8364 6.03127 14.5762 6.03127 14.2271C6.03127 13.9604 6.19631 13.7256 6.52004 13.5098L7.65627 12.7163C8.1133 12.4053 8.47512 12.2783 8.83059 12.2783C9.44631 12.2783 9.85891 12.7036 9.85891 13.3447V20.1558C9.85891 20.7397 9.54787 21.0762 9.00832 21.0762C8.47512 21.0762 8.16408 20.7334 8.16408 20.1558Z"
                                    fill="currentColor"></path>
                                <path
                                    d="M11.357 16.8804V16.4741C11.357 13.8716 12.6011 12.1704 14.6641 12.1704C16.7334 12.1704 17.9522 13.8525 17.9522 16.4741V16.8804C17.9522 19.4766 16.6953 21.1841 14.6387 21.1841C12.5821 21.1841 11.357 19.4956 11.357 16.8804ZM13.0708 16.4805V16.8677C13.0708 18.6958 13.6675 19.7876 14.6514 19.7876C15.6353 19.7876 16.232 18.6958 16.232 16.8677V16.4805C16.232 14.6587 15.6353 13.5669 14.6514 13.5669C13.6675 13.5669 13.0708 14.6523 13.0708 16.4805Z"
                                    fill="currentColor"></path>
                            </svg>
                        </v-btn>
                    </div>

                    <!-- Barra de progreso y tiempos -->
                    <div class="progress-container d-flex align-center mx-2">
                        <span class="time-display mr-2">{{ formatTime(currentAudioTime) }}</span>

                        <div class="progress-bar" @click="seekAudio">
                            <div class="progress-background"></div>
                            <div class="progress-fill" :style="{ width: audioProgressPercentage + '%' }"></div>
                            <div class="progress-thumb" :style="{ left: audioProgressPercentage + '%' }"></div>
                        </div>

                        <span class="time-display ml-2">{{ formatTime(audioDuration) }}</span>
                    </div>

                    <!-- Control de velocidad de reproducción -->
                    <div v-if="visiblePdfContainerWidth > 500" class="playback-speed-control ml-2">
                        <v-menu offset-y>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn small solo flat class="playback-speed-btn" v-bind="attrs" v-on="on">
                                    {{ playbackRate }}x

                                    <v-icon small>mdi-chevron-down</v-icon>
                                </v-btn>
                            </template>
                            <v-list dense>
                                <v-list-item v-for="speed in playbackSpeeds" :key="speed"
                                    @click="setPlaybackSpeed(speed)">
                                    <v-list-item-title :class="{ 'active-speed': playbackRate === speed }">{{ speed
                                        }}x</v-list-item-title>
                                </v-list-item>
                            </v-list>
                        </v-menu>
                    </div>
                </div>
            </div>


            <div class="pdf-document-container"
                :style="'background-color:' + teacherAudioUrl ? '#f6f6f6' : '#F6F5F1' + ';background-image: radial-gradient(#cddecd 1px, #ECF8ED 1px);'"
                ref="pdfContainer">
                <div id="pdf-viewer" ref="pdfViewer" @scroll="handleScroll"></div>
            </div>

            <!-- Fixed Zoom Controls -->
            <div v-if="visiblePdfContainerWidth > 800" class="fixed-zoom-controls rounded-lg">
                <v-btn style="height: 38px; width: 38px; min-width: 38px;" small @click="zoomOut" title="Reducir zoom"
                    :disabled="cssScale <= 0.25" class="rounded-lg rounded-r-0" :ripple="false">
                    <lucide-minus />
                </v-btn>
                <v-btn style="height: 38px; width: 38px; min-width: 38px;" small :ripple="false"
                    class="rounded-lg rounded-l-0" @click="zoomIn" title="Aumentar zoom" :disabled="cssScale >= 3">
                    <lucide-plus />
                </v-btn>
            </div>

            <!-- Audio del profesor (oculto) -->
            <audio ref="teacherAudio" class="d-none" @ended="audioEnded" @timeupdate="updateAudioTime"
                @loadedmetadata="handleAudioLoaded" v-if="teacherAudioUrl"></audio>

        </div>
        <!-- Div para efecto de blur en la parte inferior -->
        <div class="bottom-blur-effect" :style="`width: ${visiblePdfContainerWidth}px !important;`"></div>

        <!-- Overlay para cuando finaliza el audio -->
        <div v-if="showAudioEndOverlay" class="audio-end-overlay">
            <div class="overlay-content">
                <h3 class="mb-3 font-weight-medium">¡Apuntes repasados!</h3>
                <p class="mb-4">¿Qué deseas hacer ahora?</p>
                <div class="d-flex">
                    <v-btn color="grey lighten-1" outlined class="mr-3" @click="stayMore">
                        Permanecer más tiempo
                    </v-btn>
                    <v-btn color="primary" @click="goToNextSection">
                        Ir al siguiente apartado
                    </v-btn>
                </div>
            </div>
        </div>

        <features-dialog :showDialog.sync="showFeaturesDialog" />

    </div>
</template>

<script>
import * as pdfjsLib from 'pdfjs-dist';
// Importar lo necesario para la capa de texto
import 'pdfjs-dist/web/pdf_viewer.css';
import { Minus, Plus, Download, Search } from 'lucide-vue';
import FeaturesDialog from '../../../../components/premium/FeaturesDialog.vue';


export default {
    name: 'PdfViewerBlock',
    components: {
        LucideMinus: Minus,
        LucidePlus: Plus,
        LucideDownload: Download,
        LucideSearch: Search,
        FeaturesDialog
    },
    props: {
        documentId: {
            type: String,
            required: true
        },
        isPdfLoading: {
            type: Boolean,
            default: true
        },
        blockId: {
            type: [String, Number],
            required: true
        },
        blockUniqueId: {
            type: String,
            required: true
        },
        blockName: {
            type: String,
            default: 'Documento PDF'
        },
        navWidth: {
            type: Number,
            required: true
        },
        pageStart: {
            type: Number,
            default: null
        },
        pageEnd: {
            type: Number,
            default: null
        },
        pdfUrl: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            updatedMobileScale: false,
            loading: true,
            error: null,
            pdfDocument: null,
            currentPage: 1,
            totalPages: 0,
            scale: 1.0,
            cssScale: 1.0, // Nueva propiedad para el escalado CSS
            baseScale: 1.5, // Escala base alta para calidad
            pdfPagesRendered: {},
            pdfPagesLoading: {}, // Nuevo objeto para rastrear qué páginas están en proceso de carga
            pdfPageViews: {},
            scrolling: false,
            scrollTimeout: null,
            containerWidth: 0,
            resizeTimeout: null,
            resizeScaleTimeout: null, // Timeout para recalcular escala en redimensiones
            scrollOver: false,
            searchQuery: '',
            searchResults: [],
            currentResultIndex: -1,
            searching: false,
            highlightElements: [],
            currentPageInput: 1,
            lastSearchedQuery: '',
            actualPdfContainerClientWidth: 0,
            visiblePdfContainerWidth: 0,
            scrollThreshold: 104, // Valor predeterminado que será reemplazado
            showFeaturesDialog: false,
            pageHeight: 0, // Nueva propiedad para almacenar la altura promedio de página
            pageSpacing: 20, // Espaciado entre páginas (margin-bottom)
            teacherAudioUrl: null,
            isAudioPlaying: false,
            teacherExplanationContent: '', // Por si queremos mostrar el texto también
            currentAudioTime: 0,
            audioDuration: 0,
            audioProgressPercentage: 0,
            showAudioEndOverlay: false,
            showAudioPromptOverlay: false, // Nueva propiedad para controlar el overlay de pregunta
            playbackRate: 1.1,
            playbackSpeeds: [0.75, 1, 1.1, 1.25, 1.5, 1.75, 2],
            loadingProgress: 0, // Propiedad para el progreso de carga del PDF
            initialPagesToLoad: 10, // Número de páginas iniciales a cargar
            isLoadingMorePages: false, // Indicador para evitar múltiples cargas simultáneas
            pagesLoadThreshold: 3, // Cuántas páginas antes del final del contenido cargado empezar a cargar más
        };
    },
    computed: {
        // Eliminar la propiedad computada visiblePdfContainerWidth
        isPremium() {
            return this.$root.currentUser && this.$root.currentUser.premium;
        }
    },
    watch: {
        currentPage(newPage) {
            this.currentPageInput = newPage;
        },
        playbackRate(newRate) {
            if (this.$refs.teacherAudio) {
                this.$refs.teacherAudio.playbackRate = newRate;
            }
        }
    },
    mounted() {
        // Configurar el worker de PDF.js
        pdfjsLib.GlobalWorkerOptions.workerSrc = `https://cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjsLib.version}/pdf.worker.min.js`;

        // Agregar estilos globales para la selección de texto una sola vez
        this.addGlobalTextLayerStyles();

        // Obtener el ancho inicial del contenedor
        this.updateContainerWidth();



        // Si estamos en móvil, ajustar la escala inicial para que encaje en el ancho visible
        if (this.$vuetify.breakpoint.xs) {
            // Establecer un valor inicial de cssScale más pequeño para dispositivos móviles
            this.cssScale = 0.6; // Valor inicial que se ajustará cuando se cargue el PDF
        }

        // Añadir listener para el evento resize
        window.addEventListener('resize', this.updateVisiblePdfContainerWidth);
        // Añadir listener para el scroll global
        window.addEventListener('scroll', this.handleGlobalScroll);
        // Añadir listener para la tecla de reproducción/pausa multimedia
        window.addEventListener('keydown', this.handleMediaKey);

        // Inicializar con la página inicial si se especifica pageStart
        if (this.pageStart && this.pageStart > 0) {
            this.currentPage = this.pageStart;
            this.currentPageInput = this.pageStart;
        }

        this.loadPdf();
        this.loadTeacherExplanation(); // Cargar explicación del profesor

        // Actualizar el ancho visible inicial
        this.updateVisiblePdfContainerWidth();

        this.calculateScrollThreshold();

        this.$emit('section-completed');
    },
    beforeDestroy() {
        // Limpiar recursos
        if (this.pdfDocument) {
            this.pdfDocument.cleanup();
            this.pdfDocument.destroy();
        }
        this.pdfPagesRendered = {};
        this.pdfPageViews = {};

        // Eliminar event listener de resize
        window.removeEventListener('resize', this.updateVisiblePdfContainerWidth);
        // Eliminar event listener de scroll global
        window.removeEventListener('scroll', this.handleGlobalScroll);
        // Eliminar event listener para carga progresiva
        if (this.$refs.pdfViewer) {
            this.$refs.pdfViewer.removeEventListener('scroll', this.checkLoadMorePages);
        }
        window.removeEventListener('scroll', this.checkLoadMorePages);
        // Eliminar event listener de la tecla multimedia
        window.removeEventListener('keydown', this.handleMediaKey);

        // Eliminar estilos globales si es necesario
        const styleElement = document.getElementById('pdf-text-layer-styles');
        if (styleElement) {
            document.head.removeChild(styleElement);
        }

        // Clear highlight elements on destroy
        this.clearHighlights();

        // Detener la reproducción de audio si está activa
        this.stopAudio();
    },
    methods: {
        downloadPdf() {
            if (this.isPremium) {
                window.open(this.pdfUrl, '_blank');
            } else {
                this.showFeaturesDialog = true;
            }
        },
        calculateScrollThreshold() {
            this.updateActualPdfContainerClientWidth();
            // Calcular dinámicamente el umbral de scroll basado en los controles PDF
            this.$nextTick(() => {
                const pdfControls = this.$el.querySelector('.pdf-controls');
                if (pdfControls) {
                    const pdfControlsRect = pdfControls.getBoundingClientRect();
                    console.log('pdfControlsRect', pdfControlsRect);
                    // this.scrollThreshold = pdfControlsRect.top - pdfControlsRect.height;
                    this.scrollThreshold = pdfControlsRect.top - 60;
                    console.log('Umbral de scroll calculado:', this.scrollThreshold);
                }
            });
        },

        // Nuevo método para actualizar el ancho visible del contenedor PDF
        updateVisiblePdfContainerWidth() {
            const oldWidth = this.visiblePdfContainerWidth;
            this.visiblePdfContainerWidth = window.innerWidth - this.navWidth;
        },

        updateActualPdfContainerClientWidth() {
            if (this.$refs.pdfContainer) {
                this.actualPdfContainerClientWidth = this.$refs.pdfContainer.clientWidth;
                console.log('Actualitzat actualPdfContainerClientWidth a:', this.actualPdfContainerClientWidth);
            } else {
                this.actualPdfContainerClientWidth = 0;
                console.log('pdfContainer no trobat, actualPdfContainerClientWidth establert a 0');
            }
        },

        // Añadir estilos globales para la capa de texto
        addGlobalTextLayerStyles() {
            // Comprobar si ya existe
            if (document.getElementById('pdf-text-layer-styles')) {
                return;
            }

            const style = document.createElement('style');
            style.id = 'pdf-text-layer-styles';
            style.textContent = `
        /* .textLayer span::selection { */
          /* background: rgba(0, 100, 255, 0.6) !important; */ /* Comentado - Dejar que el navegador/pdfjs maneje */
        /* } */
        /* .textLayer span::-moz-selection { */
          /* background: rgba(0, 100, 255, 0.6) !important; */
        /* } */
        
        /* Efecto visual para mostrar mejor donde está el cursor */
        .textLayer span:hover {
          background-color: rgba(173, 216, 230, 0.3); /* Restaurado con un poco más de opacidad */
          border-radius: 3px;
        }
        
        /* Asegurar que el texto sea seleccionable en todos los navegadores */
        .textLayer {
          -webkit-touch-callout: text;
          -webkit-user-select: text;
          -khtml-user-select: text;
          -moz-user-select: text;
          -ms-user-select: text;
          user-select: text;
        }
      `;
            document.head.appendChild(style);
        },

        // Gestor de l'event scroll global
        handleGlobalScroll() {
            this.scrollOver = window.scrollY >= this.scrollThreshold;

            // Actualizar la página basado en la posición de scroll global
            this.detectCurrentPageByScroll();
        },

        // Método simple para detectar la página basado en posición de scroll
        detectCurrentPageByScroll() {
            // Si no hay páginas o PDF, no hacer nada
            if (!this.pdfDocument || this.totalPages <= 0) return;

            // Obtener las dimensiones de la primera página si no las tenemos
            if (this.pageHeight <= 0) {
                this.updatePageDimensions();
            }

            // Si no tenemos altura de página aún, no podemos continuar
            if (this.pageHeight <= 0) return;

            // Obtener el contenedor del PDF
            const pdfViewer = this.$refs.pdfViewer;
            if (!pdfViewer) return;

            // Obtener la posición del visor PDF relativa al documento
            const viewerRect = pdfViewer.getBoundingClientRect();
            const scrollTop = window.scrollY + viewerRect.top;

            // Calcular el offset del scroll dentro del contenedor PDF
            // considerando el padding del contenedor
            const offsetFromTop = window.scrollY - scrollTop + (pdfViewer.offsetTop || 0) + 20; // 20px es el padding aproximado

            // Calcular la página basado en el offset y la altura de página (incluyendo espaciado)
            const totalPageHeight = this.pageHeight + this.pageSpacing;
            const estimatedPage = Math.floor(offsetFromTop / totalPageHeight) + 1;

            // Asegurar que está en el rango válido
            const pageToShow = Math.max(1, Math.min(estimatedPage, this.totalPages));


            // Actualizar página si es diferente
            if (pageToShow !== this.currentPage) {
                // console.log(`Cambiando página actual de ${this.currentPage} a ${pageToShow} por cálculo de scroll`);
                this.currentPage = pageToShow;
                this.currentPageInput = pageToShow;

                // Renderizar páginas adicionales que puedan ser necesarias
                // this.renderPage(this.currentPage - 1);
                // this.renderPage(this.currentPage + 1);
            }
        },

        // Método para actualizar las dimensiones promedio de página
        updatePageDimensions() {
            // Buscar el primer contenedor de página
            const firstPage = this.$refs.pdfViewer?.querySelector('.pdf-page-container');
            if (firstPage) {
                // Obtener la altura real de la página
                this.pageHeight = firstPage.offsetHeight || firstPage.clientHeight;
                console.log(`Dimensiones de página actualizadas: Altura=${this.pageHeight}px`);
            } else {
                console.warn('No se pudo encontrar ninguna página para obtener dimensiones');
            }
        },

        handleScroll(event) {
            // Cuando hay scroll en el visor de PDF, también calculamos la página
            this.detectCurrentPageByScroll();
            // Verificar si es necesario cargar más páginas
            this.checkLoadMorePages();
        },

        // Obtener el ancho actual del contenedor
        updateContainerWidth() {
            if (this.$refs.pdfContainer) {
                // En dispositivos móviles, usar todo el ancho disponible con menos padding
                const isMobile = window.innerWidth < 600;
                const padding = isMobile ? 0 : 40;

                this.containerWidth = this.$refs.pdfContainer.clientWidth - padding;
                console.log(`Ancho del contenedor actualizado a ${this.containerWidth}px`);
            }
        },

        // Manejar evento de cambio de tamaño de la ventana
        handleResize() {
            // Debounce para evitar demasiadas renderizaciones
            if (this.resizeTimeout) {
                clearTimeout(this.resizeTimeout);
            }

            this.resizeTimeout = setTimeout(() => {
                const oldWidth = this.containerWidth;
                this.updateContainerWidth();
                this.updateActualPdfContainerClientWidth();

                // Solo re-renderizar si hay cambio significativo en el ancho (>5%)
                const widthChange = Math.abs(oldWidth - this.containerWidth) / oldWidth;
                if (widthChange > 0.05) {
                    this.recalculateScale();
                    this.reRenderAllPages();
                }
            }, 250);
        },

        // Calcular la escala basada en el ancho del contenedor
        async recalculateScale() {
            if (!this.pdfDocument || !this.containerWidth) return;

            try {
                // Obtener el tamaño original de la primera página
                const page = await this.pdfDocument.getPage(1);
                const originalViewport = page.getViewport({ scale: 1.0 });
                const originalWidth = originalViewport.width;
                const originalHeight = originalViewport.height;

                // Obtener dimensiones de la pantalla
                const screenWidth = window.innerWidth - this.navWidth;
                const screenHeight = window.innerHeight * 0.7;

                // Usar la dimensión más pequeña entre ancho y alto de pantalla
                const smallestScreenDimension = Math.min(screenWidth, screenHeight);

                // Determinar si ajustar por ancho o alto basado en la relación de aspecto de la página
                const pageAspectRatio = originalWidth / originalHeight;
                let effectiveScale;

                if (pageAspectRatio > 1) {
                    // Para páginas horizontales (más anchas que altas), ajustar al ancho
                    effectiveScale = (smallestScreenDimension - 40) / originalWidth;
                } else {
                    // Para páginas verticales (más altas que anchas), ajustar al alto
                    effectiveScale = (smallestScreenDimension - 100) / originalHeight;
                }

                // Usar una escala base alta para garantizar calidad
                this.scale = Math.max(0.5, Math.min(effectiveScale, 3.0)) * this.baseScale;

                // Configurar cssScale para mantener la relación con la escala base
                this.cssScale = 1.0;

                console.log(`Recalculada escala base a ${this.scale} (dimensión mínima de pantalla: ${smallestScreenDimension}px)`);
            } catch (error) {
                console.error('Error al recalcular la escala:', error);
            }
        },

        async loadPdf() {
            this.loading = true;
            this.error = null;
            this.loadingProgress = 0; // Inicializar progreso a 0
            console.log(`Cargando PDF para documento ID: ${this.documentId}`);

            // Usar directamente la URL del PDF proporcionada como prop
            if (this.pdfUrl) {
                this.renderPdf();
            } else {
                this.error = 'No se proporcionó URL para el PDF';
                this.loading = false;
            }
        },
        renderPdf() {
            if (!this.pdfUrl) {
                this.loading = false;
                this.$emit('update:isPdfLoading', false);
                return;
            }

            // Limpiar cualquier renderizado previo
            const pdfViewer = this.$refs.pdfViewer;
            if (pdfViewer) {
                pdfViewer.innerHTML = '';
            }

            this.pdfPagesRendered = {};
            this.pdfPageViews = {};

            // Añadir variable para almacenar el progreso de carga
            this.loadingProgress = 0;
            this.$emit('update:isPdfLoading', true);

            // Configurar opciones con callback de progreso
            const loadingOptions = {
                url: this.pdfUrl,
                onProgress: (progress) => {
                    // Calcular el porcentaje de carga
                    const percentLoaded = progress.loaded / progress.total * 100;
                    this.loadingProgress = Math.round(percentLoaded);
                    console.log(`Cargando PDF: ${this.loadingProgress}%`);
                }
            };

            pdfjsLib.getDocument(loadingOptions).promise
                .then(pdfDocument => {
                    this.pdfDocument = pdfDocument;
                    this.totalPages = pdfDocument.numPages;

                    // Asegurarse de que currentPage y pageEnd están dentro del rango válido
                    if (this.pageStart && this.pageStart > 0 && this.pageStart <= this.totalPages) {
                        this.currentPage = this.pageStart;
                    } else {
                        this.currentPage = 1;
                    }

                    if (!this.pageEnd)
                        this.pageEnd = this.totalPages

                    if (this.pageEnd && this.pageEnd > this.totalPages) {
                        console.warn(`pageEnd (${this.pageEnd}) excede el total de páginas (${this.totalPages}). Ajustando al máximo.`);
                        // No modificamos this.pageEnd directamente, solo lo consideraremos al renderizar
                    }

                    this.currentPageInput = this.currentPage;

                    this.loading = false;
                    this.$emit('update:isPdfLoading', false);

                    // Ajustar escala para dispositivos móviles
                    this.$nextTick(async () => {
                        if (this.$vuetify.breakpoint.xs) {
                            try {
                                // Obtener la primera página para calcular dimensiones
                                const page = await this.pdfDocument.getPage(1);
                                const viewport = page.getViewport({ scale: 1.0 });

                                // Calcular escala óptima basada en el ancho visible
                                // Dejamos un pequeño margen (20px a cada lado)
                                const targetWidth = this.visiblePdfContainerWidth - 40;
                                const optimalScale = targetWidth / viewport.width;

                                // Aplicar la escala calculada, con límites razonables
                                this.cssScale = Math.max(0.4, Math.min(optimalScale, 1.0));
                                console.log(`Escala ajustada para móvil: ${this.cssScale} (ancho página: ${viewport.width}, ancho visible: ${this.visiblePdfContainerWidth})`);
                            } catch (error) {
                                console.error('Error al ajustar escala para móvil:', error);
                            }
                        }

                        // Cargar inicialmente solo las primeras páginas (hasta initialPagesToLoad)
                        const startPage = this.pageStart || 1;
                        const endPage = Math.min(startPage + this.initialPagesToLoad - 1, this.pageEnd || this.totalPages);
                        console.log(`Cargando inicialmente páginas ${startPage} a ${endPage}`);

                        // Cargar las primeras páginas
                        for (let i = startPage; i <= endPage; i++) {
                            this.renderPage(i);
                        }

                        // Configurar detector de scroll para carga progresiva
                        if (this.$refs.pdfViewer) {
                            this.$refs.pdfViewer.addEventListener('scroll', this.checkLoadMorePages);
                            // También usamos el scroll global
                            window.addEventListener('scroll', this.checkLoadMorePages);
                        }
                    });
                })
                .catch(error => {
                    console.error('Error al cargar el documento PDF:', error);
                    this.error = 'Error al cargar el documento PDF';
                    this.loading = false;
                });
        },

        // Convertir coordenadas PDF a coordenadas del canvas/DOM
        convertToViewportCoords(textItem, viewport) {
            const transform = textItem.transform;
            const x = transform[4];
            const y = transform[5];
            const width = textItem.width || 0;
            // En PDF el height suele estar subestimado, por lo que fijamos un mínimo basado en el tamaño de fuente
            const height = Math.max(textItem.height || 0, 1.2); // Valor mínimo razonable para altura

            // Aplicar transformación del viewport
            const tx = pdfjsLib.Util.transform(
                viewport.transform,
                [1, 0, 0, 1, x, y]
            );

            // Calcular el tamaño de fuente basado en la transformación
            const fontSize = Math.sqrt((tx[2] * tx[2]) + (tx[3] * tx[3]));

            return {
                x: tx[4],
                y: tx[5],
                width: width * viewport.scale,
                height: height * viewport.scale,
                fontSize: fontSize
            };
        },

        async renderPage(pageNumber) {
            if (!this.pdfDocument) return;

            // Asegurarse de que el número de página es válido
            if (pageNumber < 1 || pageNumber > this.totalPages) return;
            if (pageNumber > this.pageEnd) return;


            try {
                // Si la página ya está renderizada, no hacer nada
                if (this.pdfPagesRendered[pageNumber]) {
                    // Actualizamos las dimensiones de página cuando la página 1 está lista
                    if (pageNumber === 1 && this.pageHeight <= 0) {
                        this.$nextTick(() => {
                            this.updatePageDimensions();
                        });
                    }
                    return;
                }

                // Marcar página como en proceso de carga
                this.pdfPagesLoading[pageNumber] = true;

                // Obtener la página del documento
                const page = await this.pdfDocument.getPage(pageNumber);

                // Crear un contenedor para la página
                const pageContainer = document.createElement('div');
                pageContainer.className = 'pdf-page-container';
                pageContainer.setAttribute('data-page-number', pageNumber);

                // Añadir el número de página
                const pageNumberElement = document.createElement('div');
                Object.assign(pageNumberElement.style, {
                    position: 'absolute',
                    top: '0px',
                    right: '-30px',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    color: 'white',
                    padding: '2px 8px',
                    borderRadius: '4px',
                    fontSize: '12px',
                    zIndex: '4',
                    fontWeight: '500'
                });
                const displayPageNumber = pageNumber;
                pageNumberElement.textContent = displayPageNumber;
                pageContainer.appendChild(pageNumberElement);

                // Calcular la escala para ajustar al ancho del contenedor
                const viewport = page.getViewport({ scale: this.scale });

                // Contenedor wrapper para centrar la página
                const pageWrapper = document.createElement('div');
                pageWrapper.className = 'pdf-page-wrapper';
                Object.assign(pageWrapper.style, {
                    display: 'flex',
                    justifyContent: 'center',
                    width: '100%',
                    marginBottom: `${this.pageSpacing}px`,
                    height: `${Math.floor(viewport.height * this.cssScale)}px`, // Altura ajustada por escala
                    overflow: 'visible' // Permitir que el contenido escalado sobresalga
                });

                // Añadir un indicador de carga para esta página
                const loadingElement = document.createElement('div');
                loadingElement.className = 'page-loading-indicator';
                Object.assign(loadingElement.style, {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    zIndex: '5',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    backgroundColor: 'transparent',
                    borderRadius: '8px',
                    padding: '20px',
                });

                // Crear el spinner de carga
                const spinner = document.createElement('div');
                spinner.className = 'v-progress-circular v-progress-circular--indeterminate primary--text';
                spinner.style.width = '50px';
                spinner.style.height = '50px';

                // Añadir el SVG del spinner
                spinner.innerHTML = `
                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="22.857142857142858 22.857142857142858 45.714285714285715 45.714285714285715" style="transform: rotate(0deg);">
                        <circle fill="transparent" cx="45.714285714285715" cy="45.714285714285715" r="20" stroke-width="5.714285714285714" stroke-dasharray="125.664" stroke-dashoffset="125.66370614359172px" class="v-progress-circular__overlay"></circle>
                    </svg>
                `;

                // Añadir texto de carga
                const loadingText = document.createElement('p');
                loadingText.textContent = 'Cargando página...';
                loadingText.style.marginTop = '10px';
                loadingText.style.color = '#333';
                loadingText.style.fontSize = '14px';
                loadingText.style.fontWeight = '500';

                loadingElement.appendChild(spinner);
                // loadingElement.appendChild(loadingText);

                // Establecer estilos del contenedor de la página directamente
                Object.assign(pageContainer.style, {
                    width: `${Math.floor(viewport.width)}px`,
                    height: `${Math.floor(viewport.height)}px`,
                    position: 'relative',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
                    backgroundColor: 'white',
                    overflow: 'visible', // Cambiado a visible para evitar recortes
                    transformOrigin: 'center top', // Centrar horizontalmente
                    transform: `scale(${this.cssScale})`,
                    marginBottom: '0px' // El margen ahora está en el wrapper
                });

                pageContainer.appendChild(loadingElement);
                pageWrapper.appendChild(pageContainer);
                this.$refs.pdfViewer.appendChild(pageWrapper);

                // Crear un canvas para renderizar la página
                const canvas = document.createElement('canvas');

                // Establecer estilos del canvas directamente
                Object.assign(canvas.style, {
                    display: 'block',
                    position: 'relative',
                    zIndex: '1',
                    width: '100%',
                    height: '100%'
                });

                pageContainer.appendChild(canvas);

                // Crear una capa de texto para permitir la selección
                const textLayer = document.createElement('div');
                textLayer.className = 'textLayer';

                // Establecer estilos de la capa de texto directamente
                Object.assign(textLayer.style, {
                    position: 'absolute',
                    top: '0',
                    left: '0',
                    right: '0',
                    bottom: '0',
                    width: `${Math.floor(viewport.width)}px`,
                    height: `${Math.floor(viewport.height)}px`,
                    overflow: 'hidden',
                    opacity: '0.2',
                    lineHeight: '1.0',
                    zIndex: '2',
                    fontFamily: 'sans-serif',
                    pointerEvents: 'auto'
                });

                pageContainer.appendChild(textLayer);

                // Ajustar las dimensiones del canvas considerando el devicePixelRatio
                const dpr = window.devicePixelRatio || 1;
                canvas.width = Math.floor(viewport.width * dpr);
                canvas.height = Math.floor(viewport.height * dpr);

                // Escalar el canvas con CSS para que ocupe el tamaño visual correcto
                canvas.style.width = `${Math.floor(viewport.width)}px`;
                canvas.style.height = `${Math.floor(viewport.height)}px`;

                // Obtener el contexto y escalar el dibujo
                const canvasContext = canvas.getContext('2d');
                canvasContext.scale(dpr, dpr);

                // Renderizar la página en el canvas
                const renderContext = {
                    canvasContext: canvasContext, // Usar el contexto escalado
                    viewport: viewport
                };

                // Renderizar la página
                const renderTask = page.render(renderContext);
                await renderTask.promise;

                // Obtener el contenido de texto para la capa de selección
                const textContent = await page.getTextContent();

                // Usar pdfjsLib.renderTextLayer para crear la capa de texto
                const textLayerRenderTask = pdfjsLib.renderTextLayer({
                    textContent: textContent,
                    container: textLayer,
                    viewport: viewport,
                    textDivs: [] // pdf.js creará los divs necesarios
                });

                // Marcar la página como renderizada y eliminar el indicador de carga
                this.pdfPagesRendered[pageNumber] = true;
                this.pdfPagesLoading[pageNumber] = false; // Ya no está cargando

                // Eliminar el indicador de carga una vez que la página esté completamente renderizada
                if (loadingElement && loadingElement.parentNode) {
                    loadingElement.parentNode.removeChild(loadingElement);
                }

                this.pdfPageViews[pageNumber] = { pageContainer, pageWrapper, canvas, textLayer };

                // Si es la primera página, actualizar las dimensiones
                if (pageNumber === 1) {
                    this.$nextTick(() => {
                        this.updatePageDimensions();
                        // Después de actualizar dimensiones, verificar la página actual
                        this.detectCurrentPageByScroll();
                    });
                }

                // Añadir listener para seleccionar todo el texto con doble clic
                pageContainer.addEventListener('dblclick', () => {
                    const selection = window.getSelection();
                    // Asegurarse que la capa de texto existe para esta página
                    const currentPageTextLayer = this.pdfPageViews[pageNumber]?.textLayer;

                    if (selection && currentPageTextLayer) {
                        try {
                            // Deseleccionar cualquier rango previo
                            selection.removeAllRanges();
                            // Seleccionar todos los hijos de la capa de texto
                            selection.selectAllChildren(currentPageTextLayer);
                            console.log(`Selected all text on page ${pageNumber}`);
                        } catch (e) {
                            console.error("Error selecting text on double click:", e);
                        }
                    } else {
                        console.warn(`Could not find textLayer for page ${pageNumber} on double click.`);
                    }
                });

                if (!this.updatedMobileScale) {
                    // Si estamos en móvil y hay un cambio significativo en el ancho
                    // (por ejemplo, por rotación del dispositivo), recalcular la escala
                    if (this.$vuetify.breakpoint.xs &&
                        this.pdfDocument) {

                        // Usar setTimeout para evitar demasiadas actualizaciones
                        if (this.resizeScaleTimeout) {
                            clearTimeout(this.resizeScaleTimeout);
                        }

                        this.resizeScaleTimeout = setTimeout(async () => {
                            try {
                                // Recalcular la escala óptima para el nuevo ancho
                                const page = await this.pdfDocument.getPage(1);
                                const viewport = page.getViewport({ scale: 1.0 });

                                // Calcular escala óptima con margen
                                const targetWidth = window.innerWidth;
                                const optimalScale = targetWidth / viewport.width;

                                // Aplicar nueva escala con límites
                                const oldScale = this.cssScale;
                                this.cssScale = Math.max(0.4, Math.min(optimalScale, 1.0));

                                // Actualizar visualización con la nueva escala
                                if (Math.abs(oldScale - this.cssScale) > 0.05) {
                                    this.updateCssScale(oldScale);
                                }
                            } catch (error) {
                                console.error('Error al recalcular escala después de cambio de tamaño:', error);
                            }
                        }, 300);

                        this.updatedMobileScale = true;
                    }
                }

                // ELIMINADO: Ya no cargamos páginas adyacentes aquí
                // Las páginas se cargarán mediante el sistema de carga progresiva

                // Evento para indicar que la página se ha renderizado
                this.$emit('page-rendered', pageNumber);

                // Actualizar el input si la página renderizada es la actual
                if (pageNumber === this.currentPage) {
                    this.currentPageInput = this.currentPage;
                }

            } catch (error) {
                console.error(`Error al renderizar la página ${pageNumber}:`, error);
                // Marcar la página como no cargando en caso de error
                this.pdfPagesLoading[pageNumber] = false;

                // Intenta eliminar el indicador de carga si existe
                const pageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${pageNumber}"]`);
                if (pageContainer) {
                    const loadingIndicator = pageContainer.querySelector('.page-loading-indicator');
                    if (loadingIndicator && loadingIndicator.parentNode) {
                        loadingIndicator.parentNode.removeChild(loadingIndicator);
                    }
                }
            }
        },

        prevPage() {
            if (this.currentPage > 1) {
                this.goToPage(this.currentPage - 1);
            }
        },

        nextPage() {
            if (this.currentPage < this.totalPages) {
                this.goToPage(this.currentPage + 1);
            }
        },

        goToPage(pageNum) {
            if (!this.pdfDocument) return;

            // Validar límites de página basado en pageStart/pageEnd si están definidos
            const startPage = this.pageStart || 1;
            const endPage = (this.pageEnd && this.pageEnd <= this.totalPages)
                ? this.pageEnd
                : this.totalPages;

            // Asegurarse de que la página solicitada está dentro del rango permitido
            if (pageNum < startPage) pageNum = startPage;
            if (pageNum > endPage) pageNum = endPage;

            if (pageNum < 1 || pageNum > this.totalPages) {
                console.warn(`Número de página ${pageNum} fuera de rango (1-${this.totalPages})`);
                return;
            }

            // Buscar el contenedor de página usando el atributo data-page-number
            const pageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${pageNum}"]`);
            if (pageContainer) {
                // Obtenemos el wrapper para hacer scroll, que es el padre del contenedor
                const pageWrapper = pageContainer.parentElement;
                if (pageWrapper) {
                    pageWrapper.scrollIntoView();
                } else {
                    pageContainer.scrollIntoView();
                }
            }
            else {
                // Si el contenedor no existe, probablemente sea porque aún no se ha renderizado
                // Configurar la página actual y luego intentar renderizarla
                this.currentPage = pageNum;
                this.currentPageInput = pageNum;

                // Forzar la renderización de esta página específica
                this.renderPage(pageNum).then(() => {
                    // Intentar desplazarse nuevamente después de renderizar
                    const newPageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${pageNum}"]`);
                    if (newPageContainer) {
                        const pageWrapper = newPageContainer.parentElement;
                        if (pageWrapper) {
                            pageWrapper.scrollIntoView();
                        } else {
                            newPageContainer.scrollIntoView();
                        }
                    }
                });
            }
        },

        zoomIn() {
            if (this.cssScale < 2) {
                const oldScale = this.cssScale;
                this.cssScale += 0.25;
                this.updateCssScale(oldScale);
            }
        },

        zoomOut() {
            if (this.cssScale > 0.25) {
                const oldScale = this.cssScale;
                this.cssScale -= 0.25;
                this.updateCssScale(oldScale);
            }
        },

        // Método nuevo para actualizar escala CSS
        updateCssScale(oldScale) {
            // Guardar la posición de desplazamiento actual
            const pdfViewer = this.$refs.pdfViewer;

            // Guardar la posición global de scroll de la ventana
            const windowScrollY = window.scrollY;

            // Determinar qué página está más visible en la ventana actual
            const currentVisiblePage = this.getCurrentlyVisiblePage();
            let targetPageElement = null;
            let relativePositionInPage = 0.5; // Posición relativa en la página (por defecto el centro)

            if (currentVisiblePage) {
                // Obtener el elemento de la página actual
                const pageView = this.pdfPageViews[currentVisiblePage];
                if (pageView && pageView.pageWrapper) {
                    targetPageElement = pageView.pageWrapper;

                    // Calcular la posición relativa en la página visible
                    const pageRect = targetPageElement.getBoundingClientRect();
                    const viewportHeight = window.innerHeight;
                    const pageVisibleTop = Math.max(0, pageRect.top);
                    const pageVisibleBottom = Math.min(viewportHeight, pageRect.bottom);
                    const pageVisibleCenter = (pageVisibleTop + pageVisibleBottom) / 2;

                    // Calcular posición relativa (0 = arriba, 1 = abajo)
                    relativePositionInPage = (pageVisibleCenter - pageRect.top) / pageRect.height;

                    console.log(`Página visible: ${currentVisiblePage}, posición relativa: ${relativePositionInPage.toFixed(2)}`);
                }
            }

            // Aplicar la nueva escala a todas las páginas renderizadas y ajustar espaciado
            Object.values(this.pdfPageViews).forEach(view => {
                // Verificar si las dimensiones del contenedor están definidas
                if (!view.pageContainer) return;

                // Actualizar transform scale
                view.pageContainer.style.transform = `scale(${this.cssScale})`;

                // Obtener la altura original del contenedor de página
                const originalHeight = parseInt(view.pageContainer.style.height || '0');
                const originalWidth = parseInt(view.pageContainer.style.width || '0');

                // Ajustar el margen entre páginas dinámicamente
                if (view.pageWrapper) {
                    // El espacio entre páginas debe ser proporcional a la escala
                    const adjustedSpacing = Math.max(5, this.pageSpacing * this.cssScale);
                    view.pageWrapper.style.marginBottom = `${adjustedSpacing}px`;

                    // Ajustar la altura del wrapper según la escala actual
                    view.pageWrapper.style.height = `${Math.floor(originalHeight * this.cssScale)}px`;

                    // Asegurar que el ancho del wrapper permita el contenido escalado
                    const wrapperWidth = Math.max(originalWidth * this.cssScale, this.$refs.pdfViewer.clientWidth);
                    view.pageWrapper.style.minWidth = `${Math.floor(wrapperWidth)}px`;
                }
            });

            // Esperar a que se apliquen los cambios
            this.$nextTick(() => {
                // Si tenemos un elemento de página objetivo, desplazarse a la posición relativa
                if (targetPageElement) {
                    // Calcular la nueva posición en la página
                    const newPageRect = targetPageElement.getBoundingClientRect();
                    const targetOffsetY = newPageRect.top + (newPageRect.height * relativePositionInPage);

                    // Calcular la posición central de la ventana
                    const viewportCenter = window.innerHeight / 2;

                    // Calcular el nuevo scroll para mantener la misma posición relativa
                    const newScrollY = targetOffsetY + window.scrollY - viewportCenter;

                    // Aplicar el nuevo scroll
                    window.scrollTo({
                        top: newScrollY,
                        behavior: 'auto' // Instantáneo para evitar saltos
                    });

                    console.log(`Scroll ajustado: de ${windowScrollY} a ${newScrollY}`);
                } else {
                    // Si no podemos determinar la página, intentar mantener la posición general
                    window.scrollTo({
                        top: windowScrollY,
                        behavior: 'auto'
                    });
                }
            });
        },

        // Nuevo método para determinar qué página es más visible actualmente
        getCurrentlyVisiblePage() {
            // Obtener todas las páginas renderizadas
            const pages = Object.keys(this.pdfPageViews).map(Number);
            if (!pages.length) return null;

            const viewportHeight = window.innerHeight;
            let maxVisibleArea = 0;
            let mostVisiblePage = null;

            // Iterar a través de las páginas para encontrar la más visible
            pages.forEach(pageNum => {
                const view = this.pdfPageViews[pageNum];
                if (!view || !view.pageWrapper) return;

                const pageRect = view.pageWrapper.getBoundingClientRect();

                // Calcular el área visible de la página
                const pageVisibleTop = Math.max(0, pageRect.top);
                const pageVisibleBottom = Math.min(viewportHeight, pageRect.bottom);

                // Si la página es visible en la ventana
                if (pageVisibleBottom > pageVisibleTop) {
                    const visibleArea = pageVisibleBottom - pageVisibleTop;
                    if (visibleArea > maxVisibleArea) {
                        maxVisibleArea = visibleArea;
                        mostVisiblePage = pageNum;
                    }
                }
            });

            return mostVisiblePage;
        },

        // Reemplazar el método reRenderAllPages por uno que solo actualice el CSS
        reRenderAllPages() {
            // Ya no re-renderizamos todo, solo actualizamos la escala CSS
            const oldScale = this.cssScale;
            this.cssScale = 1.0; // Resetear a escala normal
            this.updateCssScale(oldScale);
        },

        // Función para normalizar texto (eliminar acentos)
        normalizeText(text) {
            return text
                .normalize('NFD')                         // Normalizar caracteres descompuestos
                .replace(/[\u0300-\u036f]/g, '')          // Eliminar diacríticos
                .toLowerCase();                            // Convertir a minúsculas
        },

        async searchPdf() {
            if (!this.searchQuery || this.searchQuery.length < 2 || !this.pdfDocument || this.searching) {
                return;
            }
            this.searching = true;
            this.clearHighlights(); // Limpiar resaltados anteriores
            this.searchResults = [];
            this.currentResultIndex = -1;
            this.lastSearchedQuery = this.searchQuery; // Guardar la consulta actual

            console.log('Iniciando búsqueda de:', this.searchQuery);
            const query = this.searchQuery.toLowerCase();
            const promises = [];

            for (let i = 1; i <= this.totalPages; i++) {
                promises.push(this.searchInPage(i, query));
            }

            try {
                const pageResults = await Promise.all(promises);
                // Aplanar el array de resultados
                this.searchResults = pageResults.flat();
                console.log(`Búsqueda completada. Encontrados ${this.searchResults.length} resultados.`);

                if (this.searchResults.length > 0) {
                    this.currentResultIndex = 0;
                    this.highlightCurrentResult();
                    this.scrollToResult(this.searchResults[0]);
                }
            } catch (error) {
                console.error('Error durante la búsqueda en el PDF:', error);
                this.$root.showSnackbar('Error al buscar en el documento.', 'error');
            } finally {
                this.searching = false;
            }
        },

        async searchInPage(pageNum, query) {
            try {
                const page = await this.pdfDocument.getPage(pageNum);
                const textContent = await page.getTextContent();
                const viewport = page.getViewport({ scale: this.scale }); // Usar la escala actual
                const matches = [];

                // Normalizar el texto de la consulta
                const normalizedQuery = this.normalizeText(query);

                // Para cada item de texto en la página
                for (let i = 0; i < textContent.items.length; i++) {
                    const item = textContent.items[i];
                    const text = item.str;
                    const normalizedText = this.normalizeText(text);

                    // Buscar todas las ocurrencias en este fragmento de texto
                    let startIdx = normalizedText.indexOf(normalizedQuery);

                    while (startIdx !== -1) {
                        // Calculamos las coordenadas del texto actual
                        const itemCoords = this.convertToViewportCoords(item, viewport);

                        // Calcular la posición exacta de la palabra coincidente
                        // Para esto, estimamos el ancho por caracter
                        const charWidth = itemCoords.width / text.length;

                        // Posición x inicial y ancho de la coincidencia
                        const matchX = itemCoords.x + (startIdx * charWidth);
                        const matchWidth = normalizedQuery.length * charWidth;

                        // Crear un objeto de coincidencia con coordenadas precisas
                        const matchCoords = {
                            x: matchX,
                            y: itemCoords.y - itemCoords.height,
                            width: matchWidth,
                            height: itemCoords.height
                        };

                        matches.push({
                            pageNum: pageNum,
                            text: this.searchQuery, // Guardar el texto original buscado
                            coords: matchCoords,
                            viewportScale: this.scale // Guardar la escala con la que se calcularon las coords
                        });

                        // Buscar siguiente ocurrencia en este mismo fragmento de texto
                        startIdx = normalizedText.indexOf(normalizedQuery, startIdx + 1);
                    }
                }

                return matches;

            } catch (error) {
                console.error(`Error buscando en página ${pageNum}:`, error);
                return []; // Devolver array vacío en caso de error en una página
            }
        },

        clearSearch() {
            this.searchQuery = '';
            this.searchResults = [];
            this.currentResultIndex = -1;
            this.clearHighlights();
            console.log('Búsqueda limpiada.');
        },

        prevResult() {
            if (!this.searchResults.length || this.currentResultIndex <= 0) return;
            this.currentResultIndex--;
            this.highlightCurrentResult();
            this.scrollToResult(this.searchResults[this.currentResultIndex]);
        },

        nextResult() {
            if (!this.searchResults.length || this.currentResultIndex >= this.searchResults.length - 1) return;
            this.currentResultIndex++;
            this.highlightCurrentResult();
            this.scrollToResult(this.searchResults[this.currentResultIndex]);
        },

        highlightCurrentResult() {
            this.clearHighlights(); // Limpiar previos
            if (this.currentResultIndex < 0 || this.currentResultIndex >= this.searchResults.length) {
                return;
            }

            const result = this.searchResults[this.currentResultIndex];
            this.addHighlight(result, true); // Marcar como resultado actual

            // Opcional: añadir highlights para otros resultados en la misma página
            this.searchResults.forEach((res, index) => {
                if (res.pageNum === result.pageNum && index !== this.currentResultIndex) {
                    this.addHighlight(res, false);
                }
            });
        },

        addHighlight(result, isCurrent) {
            const pageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${result.pageNum}"]`);
            if (!pageContainer) {
                console.warn(`Contenedor para página ${result.pageNum} no encontrado al intentar resaltar.`);
                // Podríamos intentar renderizar la página si no existe?
                // await this.renderPage(result.pageNum);
                // pageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${result.pageNum}"]`);
                // if (!pageContainer) return;
                return;
            }

            const highlightDiv = document.createElement('div');
            highlightDiv.className = 'search-highlight';
            if (isCurrent) {
                highlightDiv.classList.add('current-result');
            }

            // Ajustar coords si la escala actual es diferente a la de la búsqueda
            let coords = result.coords;
            if (result.viewportScale !== this.scale) {
                const scaleFactor = this.scale / result.viewportScale;
                coords = {
                    x: result.coords.x * scaleFactor,
                    y: result.coords.y * scaleFactor,
                    width: result.coords.width * scaleFactor,
                    height: result.coords.height * scaleFactor
                };
            }

            Object.assign(highlightDiv.style, {
                position: 'absolute',
                left: `${coords.x}px`,
                top: `${coords.y}px`,
                width: `${coords.width}px`,
                height: `${coords.height}px`,
                backgroundColor: isCurrent ? 'rgba(76, 175, 80, 0.6)' : 'rgba(129, 199, 132, 0.4)', // Verde intenso para actual, verde claro para otros
                borderRadius: '2px',
                pointerEvents: 'none', // Para no interferir con la selección de texto
                zIndex: 3 // Encima de la capa de texto pero debajo de controles
            });

            pageContainer.appendChild(highlightDiv);
            this.highlightElements.push(highlightDiv); // Guardar referencia para limpiar
        },

        clearHighlights() {
            this.highlightElements.forEach(el => el.remove());
            this.highlightElements = [];
        },

        scrollToResult(result) {
            if (!result) return;

            // Asegurarse que la página del resultado está renderizada
            this.renderPage(result.pageNum).then(() => {
                const pageContainer = this.$refs.pdfViewer.querySelector(`[data-page-number="${result.pageNum}"]`);
                if (pageContainer) {
                    // Intentar hacer scroll al contenedor de la página primero
                    pageContainer.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

                    // Encontrar el highlight específico (puede que no esté añadido aún si es async)
                    // Podemos hacer scroll al contenedor como aproximación
                    // O esperar un tick para que se añada el highlight
                    this.$nextTick(() => {
                        const currentHighlight = pageContainer.querySelector('.search-highlight.current-result');
                        if (currentHighlight) {
                            // Scroll más preciso al propio highlight
                            currentHighlight.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
                        } else {
                            // Fallback si el highlight no se encuentra (scroll a la página ya hecho)
                            console.warn("Highlight actual no encontrado para scroll preciso.");
                        }
                    });

                    // Actualizar currentPage si es necesario (ya que el scroll puede no activarlo a tiempo)
                    if (this.currentPage !== result.pageNum) {
                        this.currentPage = result.pageNum;
                        this.currentPageInput = result.pageNum; // Sincronizar input aquí también
                    }

                } else {
                    console.warn(`Contenedor para página ${result.pageNum} no encontrado para hacer scroll.`);
                }
            }).catch(error => {
                console.error(`Error renderizando página ${result.pageNum} para scroll:`, error);
            });
        },

        // Nuevo método para manejar la entrada del textfield
        goToPageInput() {
            let pageNum = parseInt(this.currentPageInput);

            // Aplicar restricciones de pageStart/pageEnd
            const startPage = this.pageStart || 1;
            const endPage = (this.pageEnd && this.pageEnd <= this.totalPages)
                ? this.pageEnd
                : this.totalPages;

            if (isNaN(pageNum)) {
                // Si no es un número, restaurar al valor actual
                this.currentPageInput = this.currentPage;
                return;
            }

            // Ajustar automáticamente si está fuera de rango
            if (pageNum < startPage) {
                pageNum = startPage;
                this.currentPageInput = startPage;
            } else if (pageNum > endPage) {
                pageNum = endPage;
                this.currentPageInput = endPage;
            }

            console.log(`Navegando a la página ${pageNum}`);
            this.goToPage(pageNum);
        },

        // Manejar blur para validar/restaurar el valor si no se presionó Enter
        handlePageInputBlur() {
            // Validar el número de página ingresado
            let pageNum = parseInt(this.currentPageInput);

            // Aplicar restricciones de pageStart/pageEnd si existen
            const startPage = this.pageStart || 1;
            const endPage = (this.pageEnd && this.pageEnd <= this.totalPages)
                ? this.pageEnd
                : this.totalPages;

            if (isNaN(pageNum)) {
                // Si no es un número, restaurar al valor actual
                this.currentPageInput = this.currentPage;
                return;
            }

            // Ajustar automáticamente si está fuera de rango
            if (pageNum < startPage) {
                pageNum = startPage;
                this.currentPageInput = startPage;
            } else if (pageNum > endPage) {
                pageNum = endPage;
                this.currentPageInput = endPage;
            }

            // Navegar a la página solo si es diferente a la actual
            if (pageNum !== this.currentPage) {
                console.log(`Navegando a la página ${pageNum} (desde blur)`);
                this.goToPage(pageNum);
            }
        },

        // Método para gestionar Enter en la búsqueda
        handleEnterKey(event) {
            // Si la consulta ha cambiado desde la última búsqueda o está vacía, siempre buscar de nuevo
            if (this.searchQuery !== this.lastSearchedQuery || this.searchResults.length === 0) {
                this.searchPdf();
                return;
            }

            // Si la consulta es la misma que la última búsqueda, navegar entre resultados
            if (event.shiftKey) {
                // Si shift está presionado, ir al resultado anterior
                if (this.searchResults.length > 0 && this.currentResultIndex > 0) {
                    this.prevResult();
                }
            } else {
                // Comportamiento normal (ir al siguiente resultado)
                if (this.searchResults.length > 0) {
                    this.nextResult();
                }
            }
        },

        // Métodos para gestionar la explicación del profesor
        async loadTeacherExplanation() {
            if (!this.blockId) return;

            try {
                console.log(`Cargando explicación del profesor para el bloque ID ${this.blockId}...`);
                const response = await this.axios.get(`/blocks/${this.blockId}/teacher-explanation`, {
                    headers: { Authorization: this.$root.token.value }
                });

                if (response.data.success && response.data.explanation) {
                    console.log('Explicación del profesor cargada con éxito');
                    this.teacherExplanationContent = response.data.explanation.content;
                    this.teacherAudioUrl = response.data.explanation.audioUrl + (response.data.explanation.audioUrl.endsWith('.mp3') ? '' : '.mp3');
                    this.audioDuration = response.data.explanation.audioDuration || 0;

                    // En lugar de reproducir automáticamente, esperar a que se cargue el audio
                    // y mostrar el overlay de pregunta
                    this.$nextTick(() => {
                        // this.showAudioPromptOverlay = true;

                        // Configurar el audio pero sin reproducirlo
                        if (this.$refs.teacherAudio && this.teacherAudioUrl) {
                            this.$refs.teacherAudio.src = this.teacherAudioUrl;
                            this.$refs.teacherAudio.playbackRate = 1.1;

                            // Ahora la duración viene directamente de la API, no necesitamos el evento loadedmetadata
                            // Solo lo mantenemos para casos donde la duración no venga de la API
                            if (!this.audioDuration) {
                                this.$refs.teacherAudio.addEventListener('loadedmetadata', () => {
                                    this.audioDuration = this.$refs.teacherAudio.duration;
                                });
                            }
                        }
                    });
                } else {
                    console.log('No se encontró explicación del profesor para este bloque');
                }
            } catch (error) {
                console.error('Error al cargar la explicación del profesor:', error);
            }
        },

        // Nuevo método para iniciar la reproducción después de aceptar en el overlay
        startAudio() {
            this.showAudioPromptOverlay = false;
            this.playAudio();
        },

        // Nuevo método para omitir la reproducción
        skipAudio() {
            this.showAudioPromptOverlay = false;
        },

        playAudio() {
            if (!this.teacherAudioUrl || !this.$refs.teacherAudio) return;

            const audioPlayer = this.$refs.teacherAudio;

            // Sólo establecer la URL si no está ya cargada
            if (!audioPlayer.src || audioPlayer.src !== this.teacherAudioUrl) {
                audioPlayer.src = this.teacherAudioUrl;
            }

            audioPlayer.play()
                .then(() => {
                    this.isAudioPlaying = true;
                    console.log('Reproduciendo audio de explicación del profesor');
                })
                .catch(err => {
                    console.error('Error al reproducir audio:', err);
                });
        },

        pauseAudio() {
            if (!this.$refs.teacherAudio) return;

            this.$refs.teacherAudio.pause();
            this.isAudioPlaying = false;
        },

        stopAudio() {
            if (!this.$refs.teacherAudio) return;

            this.$refs.teacherAudio.pause();
            this.$refs.teacherAudio.currentTime = 0;
            this.isAudioPlaying = false;
        },

        toggleAudio() {
            if (this.isAudioPlaying) {
                this.pauseAudio();
            } else {
                this.playAudio();
            }
        },

        audioEnded() {
            this.isAudioPlaying = false;
            this.showAudioEndOverlay = true;
        },

        updateAudioTime(event) {
            this.currentAudioTime = event.target.currentTime;
            this.calculateAudioProgress();
        },

        handleAudioLoaded(event) {
            this.audioDuration = event.target.duration;
            this.calculateAudioProgress();

            // Aplicar la velocidad de reproducción configurada
            if (this.$refs.teacherAudio) {
                this.$refs.teacherAudio.playbackRate = this.playbackRate;
            }
        },

        calculateAudioProgress() {
            if (this.audioDuration > 0) {
                this.audioProgressPercentage = (this.currentAudioTime / this.audioDuration) * 100;
            }
        },

        skipBackward() {
            if (!this.$refs.teacherAudio) return;

            if (this.$refs.teacherAudio.currentTime > 10) {
                this.$refs.teacherAudio.currentTime -= 10;
            } else {
                this.$refs.teacherAudio.currentTime = 0;
            }
        },

        skipForward() {
            if (!this.$refs.teacherAudio) return;

            if (this.$refs.teacherAudio.currentTime < this.audioDuration - 10) {
                this.$refs.teacherAudio.currentTime += 10;
            } else {
                this.$refs.teacherAudio.currentTime = this.audioDuration;
            }
        },

        seekAudio(event) {
            if (!this.$refs.teacherAudio) return;

            const progressBar = event.currentTarget;
            const rect = progressBar.getBoundingClientRect();
            const clickPosition = (event.clientX - rect.left) / rect.width;

            // Establecer la nueva posición del audio
            this.$refs.teacherAudio.currentTime = this.audioDuration * clickPosition;
        },

        formatTime(seconds) {
            const minutes = Math.floor(seconds / 60);
            const remainingSeconds = Math.round(seconds % 60);
            return `${minutes}:${remainingSeconds.toString().padStart(2, '0')}`;
        },

        stayMore() {
            this.$emit('section-completed', { type: 'pdf-section' });

            this.showAudioEndOverlay = false;
        },

        goToNextSection() {
            // Marcar la sección actual como completada
            this.$emit('section-completed', { type: 'pdf-section' });

            // Cerrar el overlay
            this.showAudioEndOverlay = false;

            // Navegar al siguiente apartado (esto depende de la implementación del componente padre)
            this.$emit('request-navigation-next');
        },

        setPlaybackSpeed(speed) {
            this.playbackRate = speed;
            if (this.$refs.teacherAudio) {
                this.$refs.teacherAudio.playbackRate = speed;
            }
        },

        // Método para manejar teclas multimedia (reproducción/pausa)
        handleMediaKey(event) {
            // Tecla de play/pause multimedia (puede variar según el navegador y sistema operativo)
            // El código 179 es para la tecla multimedia Play/Pause en muchos navegadores
            // El código 19 suele ser para la tecla Pause en algunos sistemas
            // También comprobamos keyCode 415 (Play) y 416 (Pause) para Smart TV y algunos dispositivos
            if (event.keyCode === 179 || event.keyCode === 19 || event.keyCode === 415 || event.keyCode === 416) {
                console.log('Tecla multimedia de pausa/reproducción detectada:', event.keyCode);
                this.toggleAudio();
                event.preventDefault();
            }
        },

        // Método para comprobar si es necesario cargar más páginas
        checkLoadMorePages() {
            if (!this.pdfDocument || this.isLoadingMorePages) return;

            // Obtener el contenedor del visor PDF
            const pdfViewer = this.$refs.pdfViewer;
            if (!pdfViewer) return;

            // Calcular la posición de scroll
            const scrollPosition = window.scrollY + window.innerHeight;
            const maxScrollPosition = document.body.scrollHeight;

            // Calcular qué tan cerca estamos del final (en porcentaje)
            const scrollPercentage = (scrollPosition / maxScrollPosition) * 100;

            // Si estamos cerca del final (dentro del 20% final), cargar más páginas
            if (scrollPercentage > 80) {
                // Determinar la última página cargada
                const renderedPages = Object.keys(this.pdfPagesRendered).map(Number).sort((a, b) => a - b);

                if (renderedPages.length > 0) {
                    const lastRenderedPage = renderedPages[renderedPages.length - 1];

                    // Si aún hay más páginas por cargar dentro del rango pageStart-pageEnd
                    if (lastRenderedPage < (this.pageEnd || this.totalPages)) {
                        this.loadMorePages(lastRenderedPage);
                    }
                }
            }
        },

        // Método para cargar más páginas
        loadMorePages(lastRenderedPage) {
            if (this.isLoadingMorePages) return;

            this.isLoadingMorePages = true;

            // Determinar cuántas páginas más cargar (usar initialPagesToLoad como referencia)
            const nextPagesToLoad = this.initialPagesToLoad || 10;
            const startPage = lastRenderedPage + 1;
            const endPage = Math.min(startPage + nextPagesToLoad - 1, this.pageEnd || this.totalPages);

            console.log(`Cargando más páginas: ${startPage} a ${endPage} (de ${this.totalPages} totales)`);

            // Crear array de promesas para cargar las páginas
            const renderPromises = [];

            for (let i = startPage; i <= endPage; i++) {
                // Solo renderizar si aún no está renderizada o en proceso
                if (!this.pdfPagesRendered[i] && !this.pdfPagesLoading[i]) {
                    renderPromises.push(this.renderPage(i));
                }
            }

            // Cuando todas las páginas se hayan cargado
            Promise.all(renderPromises)
                .then(() => {
                    console.log(`Páginas ${startPage} a ${endPage} cargadas correctamente`);
                    this.isLoadingMorePages = false;
                })
                .catch(error => {
                    console.error('Error al cargar más páginas:', error);
                    this.isLoadingMorePages = false;
                });
        },
    }
};
</script>

<style scoped>
.fixed-controls {
    position: fixed;
    top: 60px;
    left: 0;
    bottom: 0;
    height: 40px;
    z-index: 100;
}

.fixed-audio-bar {
    position: fixed;
    top: 60px;
    left: 0;
    bottom: 0;
    height: 40px;
    z-index: 100;
    border-bottom: 1px solid #E5E5E8;
}

.pdf-viewer-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.loading-container,
.error-container,
.no-pdf-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 400px;
}

.pdf-controls {
    display: flex;
    align-items: center;
    background-color: #f9f9f9;
    padding: 0px 16px;
    height: 40px !important;
    min-height: 40px;
    /* Use min-height to allow wrapping */
    height: auto;
    /* Allow height to adjust based on content */
    border-radius: 0px;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
    flex-wrap: wrap;
    /* Permitir el wrapping in dispositivos pequeños */
}

.search-controls .v-text-field {
    max-height: 30px;
    /* Reducir altura máxima del contenedor */
}

.search-controls .v-text-field>>>input {
    font-size: 13px;
    /* Reducir tamaño de fuente */
}

.search-controls .v-text-field>>>.v-input__slot {
    min-height: 30px !important;
}

.search-controls .v-text-field>>>.v-input__append-inner {
    margin-top: 2px !important;
}

.navigation-controls,
.zoom-controls {
    display: flex;
    align-items: center;
    /* Para cuando se hace wrap */
}

.search-controls {
    /* Ensure search controls take available width */
    width: 100%;
}

.page-info,
.zoom-level {
    padding: 0 8px;
    min-width: 60px;
    text-align: center;
    font-size: 14px;
}

/* Estilo adicional para el span del total de páginas */
.page-total {
    font-size: 14px;
    margin-left: -5px;
    /* Acercarlo al input */
    margin-right: 8px;
}

/* Estilo para el input de página */
.page-input.v-text-field {
    max-width: 30px !important;
    max-height: 30px !important;
    /* Copiado de search-controls */
}

/* Estilo para el input de página */
.page-input>>>fieldset {
    border-radius: 10px !important;
}

.page-input.v-text-field--outlined>>>fieldset {
    padding-left: 8px !important;
    padding-right: 8px !important;
}

.page-input>>>.v-input__slot {
    min-height: 20px !important;
    /* Copiado de search-controls */
    padding: 0 !important;
}

.page-input>>>input {
    text-align: center;
    padding: 8px 0 !important;
    /* Ajustar padding vertical */
    font-size: 13px;
    max-height: 30px !important;
    /* Copiado de search-controls */
    /* Ocultar flechas de input numérico */
    -moz-appearance: textfield;
    /* Firefox */
}

.page-input>>>input::-webkit-outer-spin-button,
.page-input>>>input::-webkit-inner-spin-button {
    /* Chrome, Safari, Edge, Opera */
    -webkit-appearance: none;
    margin: 0;
}

.pdf-document-container {
    flex: 1;
    overflow: auto;
    opacity: 1;
    background-size: 20px 20px;
    background-repeat: repeat;
    /* min-height: calc(100vh - 100px); */
}

#pdf-viewer {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 20px;
    overflow-x: auto !important;
    scrollbar-width: none;
    /* Ocultar scrollbar en Firefox */
    -ms-overflow-style: none;
    /* Ocultar scrollbar en IE y Edge */
}

#pdf-viewer::-webkit-scrollbar {
    display: none;
    /* Ocultar scrollbar en Chrome, Safari y Opera */
}

.pdf-page-container {
    margin-bottom: 10px;
    position: relative !important;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
    background-color: white;
    overflow: visible !important;
    /* Cambiado a visible para evitar recortes */
    max-width: none !important;
    /* Eliminar limitación de ancho */
}

.pdf-page-container canvas {
    display: block;
    position: relative;
    z-index: 1;
    width: 100%;
    height: 100%;
}

/* Estilos para la capa de texto seleccionable */
.textLayer {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    overflow: hidden;
    opacity: 0.2;
    line-height: 1.0;
    z-index: 2;
    font-family: sans-serif;
}

.textLayer:hover {
    opacity: 0.5;
}

.textLayer span {
    color: transparent;
    position: absolute;
    white-space: pre;
    cursor: text;
    transform-origin: 0% 0%;
    pointer-events: auto;
    user-select: text;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
}

/* .textLayer ::selection { */
/* background: rgba(0, 100, 255, 0.4); */
/* } */

/* .textLayer ::-moz-selection { */
/* background: rgba(0, 100, 255, 0.4); */
/* } */

.textLayer .highlight {
    margin: -1px;
    padding: 1px;
    background-color: rgb(180, 0, 170);
    border-radius: 4px;
}

.textLayer .highlight.begin {
    border-radius: 4px 0 0 4px;
}

.textLayer .highlight.end {
    border-radius: 0 4px 4px 0;
}

.textLayer .highlight.middle {
    border-radius: 0;
}

.textLayer .highlight.selected {
    background-color: rgb(0, 100, 0);
}

/* Media queries para dispositivos móviles */
@media (max-width: 600px) {
    .pdf-controls {
        padding: 5px 10px;
        /* justify-content: center; */
        /* Removed to allow v-row to manage alignment */
    }

    .navigation-controls,
    .zoom-controls {
        margin-right: 0;
        /* Removed margin for better centering/spacing by v-col */
        justify-content: center;
        /* Center pagination on small screens */
        width: 100%;
        /* Allow pagination to take full width if needed */
    }

    .pdf-document-container {
        /* height: calc(100vh - 170px); */
        /* Más compacto en móviles */
    }

    #pdf-viewer {
        padding: 10px;
    }

    .page-info,
    .zoom-level {
        min-width: 40px;
        font-size: 12px;
    }

    /* Ajustar input y total en móviles */
    .page-input {
        width: 45px !important;
    }

    .page-total {
        font-size: 12px;
        margin-right: 5px;
    }

    /* Ocultar botones menos importantes en móviles - No es necesario ocultar con la nueva estructura responsive */
    /* .pdf-controls .v-btn.mr-2 {
        display: none;
    } */
}

/* Estilos para los resaltados de búsqueda */
.search-highlight {
    position: absolute;
    background-color: rgba(129, 199, 132, 0.4);
    /* Verde claro por defecto */
    border-radius: 2px;
    pointer-events: none;
    /* No interferir con selección */
    z-index: 3;
    /* Por encima de textLayer */
    transition: background-color 0.3s ease;
}

.search-highlight.current-result {
    background-color: rgba(76, 175, 80, 0.6);
    /* Verde más intenso */
    box-shadow: 0 0 3px 1px rgba(76, 175, 80, 0.8);
}

/* Estilos para los controles de zoom fijos */
.fixed-zoom-controls {
    position: fixed;
    bottom: 18px;
    left: 20px;
    z-index: 101;
    /* Asegurar que esté por encima de otros elementos */
    display: flex;
    background-color: rgba(255, 255, 255, 0.8);
    /* Fondo semitransparente */
    border-radius: 4px;
    /* box-shadow: 0 2px 5px rgba(0, 0, 0, 0.2); */
    box-shadow: 0 3px 0 #dadada !important;
    border: 1px solid #e9e9e9 !important;
}

.fixed-zoom-controls .v-btn {
    background-color: white !important;
    /* Forzar fondo blanco si es necesario */
}

.premium-btn-wrapper {
    position: relative;
    display: inline-block;
    padding: 2px;
    background: linear-gradient(45deg, #01FF88, #00B42E);
    border-radius: 8px;
    margin: 0;
}

.premium-download-btn {
    position: relative;
    margin: 0 !important;
    border-radius: 6px !important;
}

.premium-download-btn:hover {
    transform: translateY(-1px);
}

.fixed-audio-controls {
    display: none;
}

.audio-player-bar {
    height: 60px;
    background-color: white;
    backdrop-filter: blur(10px);
    display: flex;
    align-items: center;
    padding: 0 20px;
    z-index: 101;
}



.audio-controls {
    display: flex;
    align-items: center;
    width: 100%;
    max-width: 800px;
    margin: 0 auto;
}

.progress-container {
    flex: 1;
    margin: 0 15px;
    cursor: pointer;
}

.progress-bar {
    width: 100%;
    height: 4px;
    background-color: rgba(103, 103, 103, 0.2);
    border-radius: 2px;
    overflow: visible;
    position: relative;
    cursor: pointer;
}

.progress-background {
    display: none;
}

.progress-fill {
    height: 100%;
    background-color: #1DB954;
    /* Color verde Spotify */
    position: absolute;
    top: 0;
    left: 0;
    border-radius: 2px;
}

.progress-thumb {
    width: 12px;
    height: 12px;
    background-color: #fff;
    border-radius: 50%;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    opacity: 0;
    transition: opacity 0.2s;
}

.progress-bar:hover .progress-thumb {
    opacity: 1;
}

.time-display {
    font-size: 12px;
    color: #2b2b2b;
    min-width: 35px;
    text-align: center;
}

.play-btn {
    color: white;
}

/* Estilos para el overlay al finalizar el audio */
.audio-end-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 999;
}

.overlay-content {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    width: fit-content
}

/* Estilos para el indicador del número de página */
.page-number-indicator {
    position: absolute;
    top: 10px;
    left: -30px !important;
    background-color: rgba(0, 0, 0, 0.6);
    color: white;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 12px;
    z-index: 4;
    font-weight: 500;
}

.playback-speed-control {
    display: flex;
    align-items: center;
}

.playback-speed-btn {
    margin-left: 10px;
    font-size: 12px;
    height: 28px !important;
    min-width: 40px !important;
    padding: 0 8px !important;
    border-color: #e0e0e0 !important;
}

.active-speed {
    color: #1DB954;
    font-weight: 500;
}

.audio-prompt-overlay-content {
    background-color: white;
    padding: 30px;
    border-radius: 10px;
    text-align: center;
    max-width: 450px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.1);
    color: black !important;
    position: relative;
    z-index: 1;
    margin: auto;
}

.audio-prompt-overlay-custom {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
}

/* Estilos para el indicador de carga de página */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.v-progress-circular--indeterminate svg {
    animation: rotate 1.4s linear infinite;
}

.v-progress-circular__overlay {
    stroke: #1976d2;
    /* Color primario */
    stroke-dasharray: 80, 200;
    stroke-dashoffset: 0px;
    transition: stroke-dasharray 0.6s ease 0s, stroke 0.6s ease 0s;
}
</style>